import React from 'react'
import { CircularProgress } from '@mui/material'
import { styled } from '@mui/material/styles'

const Root = styled('div')({
  position: 'relative'
})

const BottomCircularProgress = styled(CircularProgress)(({ theme }) => ({
  color: theme.palette.grey[200]
}))

const TopCircularProgress = styled(CircularProgress)(({ theme }) => ({
  color: theme.palette.allPrimary?.[600],
  position: 'absolute',
  left: 0,
  '& .MuiCircularProgress-circle': {
    strokeLinecap: 'round'
  }
}))

function AsterCircularProgress(props) {
  return (
    <Root>
      <BottomCircularProgress variant="determinate" size={80} thickness={3} {...props} value={100} />
      <TopCircularProgress variant="indeterminate" disableShrink size={80} thickness={4} {...props} />
    </Root>
  )
}

export default AsterCircularProgress
